import download from 'downloadjs';
import { baseRequest } from '../utils';
 
const types = {
  EXPORT_REPORT_REQUEST: 'EXPORT_REPORT_REQUEST',
  EXPORT_REPORT_SUCCESS: 'EXPORT_REPORT_SUCCESS',
  EXPORT_REPORT_ERROR: 'EXPORT_REPORT_ERROR',
}
// Action creators
const exportReportRequest = () => ({
  type: types.EXPORT_REPORT_REQUEST,
});

const exportReportSuccess = (payload) => ({
  type: types.EXPORT_REPORT_SUCCESS,
  payload,
});

const exportReportError = (error) => ({
  type: types.EXPORT_REPORT_ERROR,
  payload: error,
});

// Thunk action for generating a report
export const exportReport = ({ id, params, fileName = 'report.xlsx' }) => {
  
  return (dispatch) => {
    dispatch(exportReportRequest());

    return baseRequest(
      'POST',
      `/reports/generate`,
      { id, params }, [], [], 'blob'
         
    )
      .then((response) => {
        const extension = response.headers['content-type'] === 'text/csv' ? 'csv' : 'xlsx';
        const fileName = id === 'riders-upload-records' ? 'Import_riders_summary' : 'Report';
        download(new Blob([response.data]), `${fileName}.${extension}`, response.headers['content-type']);

        dispatch(exportReportSuccess(response.data));
      })
      .catch(async (error) => {
        dispatch(exportReportError(error?.response || error));
      });
  };
};

// Initial state
const initialState = {
  loading: false,
  data: null,
  error: null,
};

// Reducer
export default function reportsReducer(state = initialState, action) {
  switch (action.type) {
    case types.EXPORT_REPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case types.EXPORT_REPORT_SUCCESS:
      return { ...state, data: action.payload, error: null };
    case types.EXPORT_REPORT_ERROR:
      console.log('error reducer', action)
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}